import {catchError, filter, mergeMap, switchMap, take} from 'rxjs/operators'
import {appInitAction, noopAction} from 'util/ReduxUtil'
import {from, of} from 'rxjs'
import axios from 'axios'
import {alertServerError} from 'module/ConfirmDialog/component/ConfirmDialogContainer'
import {Epic} from 'redux-observable'
import {resetCFDefGroupsAction} from 'module/CFGroup/action/CFGroupAction'

const initCFDefGroupEpic: Epic = (action$) => action$.pipe(
	filter(appInitAction.match),
	take(1),
	switchMap(
		() => from(axios.get("../json/cfGroup/permittedGroups")
			.then(({data}) => data)).pipe(
			mergeMap((data) => [resetCFDefGroupsAction(data)]),
			catchError((err) => {
				void alertServerError(err);
				return of(noopAction()); // don't stop here
			}),
		),
	),
)

export const CFGroupEpic = initCFDefGroupEpic